import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,        // 30 seconds default
      gcTime: 5 * 60 * 1000,       // 5 minutes garbage collection
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Query keys for type-safe cache management
export const queryKeys = {
  subscription: ['subscription'] as const,
  bots: ['bots'] as const,
  documents: ['documents'] as const,
  analytics: (botId?: string, days?: number) => ['analytics', botId, days] as const,
};
